"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.endpoints = void 0;
exports.endpoints = {
    authUrl: 'Account/Login',
    fakeAuthUrl: 'Account/Test',
    dashboard: 'Dashboard',
    adminDashboard: 'Dashboard/Admin',
    permission: 'Permission',
    app: 'App',
    translation: 'Translation',
    translationKey: 'TranslationKey',
    translationReport: 'TranslationReport',
    translationImage: 'TranslationImage',
    translationKeySearchDropdown: 'translationKey/SearchDropdown',
    translationStatLeaderboard: 'translationStats/TranslatorLeaderboard',
    user: 'User',
    language: 'Language',
    userActivity: 'UserActivity',
    cache: 'Cache',
    version: 'Version',
    donation: 'Donation',
    redisCache: 'Cache/Redis',
    webhookMessages: 'WebhookMessage',
    appReviews: 'AppReview',
    translationSearch: 'Translation/Search',
    translationSearchPerLanguage: 'Translation/Graph/TranslationsPerLanguage',
    teamMember: 'TeamMember',
    steam: 'Steam',
    steamNews: 'Steam/News',
    steamBranches: 'Steam/Branches',
    licence: 'Licence',
    licenceActivate: 'Licence/Activate',
    licenceActivateForPatron: 'Licence/ActivateForPatron',
    licenceVerify: 'Licence/Verify',
    versionSendUpdateNotification: 'Version/SendUpdateNotification',
    guideDetail: 'GuideDetail',
    guideDetailSearchAdmin: 'GuideDetail/SearchAdmin',
    appNotice: 'AppNotice',
    feedbackForm: 'Feedback',
    feedbackFormQuestion: 'FeedbackQuestion',
    feedbackFormAnswer: 'FeedbackAnswer',
    badge: 'Badge',
    patreon: 'Patreon',
    quickAction: 'QuickAction',
    quickActionIndexes: 'QuickAction/Indexes',
    contact: 'Contact',
    oAuth: 'OAuth',
};
